/**@internal */
export var CustomAction;
(function (CustomAction) {
    CustomAction[CustomAction["SendEmailVerificationRequest"] = 16] = "SendEmailVerificationRequest";
    CustomAction[CustomAction["SendSMSRequest"] = 513] = "SendSMSRequest";
    CustomAction[CustomAction["SendEmailRequest"] = 514] = "SendEmailRequest";
    CustomAction[CustomAction["UnlockActiveIdHardwareToken"] = 515] = "UnlockActiveIdHardwareToken";
})(CustomAction || (CustomAction = {}));
//# sourceMappingURL=actions.js.map